<template>
    <div class="field">
        <transition name="fade">
            <label v-if="title" class="field-label">
                {{ title }}
                <span class="required">{{ required ? '*' : '' }}</span>
                <tooltip v-if="hint" :text="hint"></tooltip>
            </label>
        </transition>
        <input
            ref="widget"
            class="field-input"
            style="width: 100%;"
            type="date"
            :name="name"/>
    </div>
</template>

<script type="text/babel">
export default {
    name: 'kendo-datepicker',
    props: {
        hint: String,
        depth: String,
        label: String,
        name: String,
        placeholder: String,
        format: {
            type: String,
            default: 'd/M/yyyy'
        },
        required: Boolean,
        value: Date
    },
    data () {
        const config = {
            change: this.onChange,
            value: this.value,
            format: this.format,
            start: {
                type: String,
                default: 'month'
            }
        };

        if (this.depth) {
            config.depth = this.depth;
            config.start = this.depth;
        }

        return {
            title: this.value ? this.label || this.placeholder : '',
            widget: undefined,
            config
        };
    },
    mounted () {
        this.widget = new kendo.ui.DatePicker(this.$refs.widget, this.config);
    },
    destroyed () {
        this.widget.destroy();
    },
    methods: {
        onChange (e) {
            const value = e.sender.value();
            this.$emit('change', value);
            this.$emit('input', value);
        }
    },
    watch: {
        value (value) {
            if (value) {
                this.title = this.label || this.placeholder;
            } else {
                this.title = '';
            }
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    $helpColor: #ff3860;
    $labelColor: #bdc3c7;

    .field {
        margin: 24px 0 0;
        width: 100%;
    }

    .required {
        color: $helpColor;
    }

    // Animations
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-datepicker/kendo-datepicker.component.vue